import * as React from "react"
import { H2 } from './typography'
const PostTitle = (props) => <H2 {...props} />

export default PostTitle
